import { render, staticRenderFns } from "./lk-date.vue?vue&type=template&id=604f9277&"
import script from "./lk-date.vue?vue&type=script&lang=js&"
export * from "./lk-date.vue?vue&type=script&lang=js&"
import style0 from "./lk-date.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-date/lk-date.vue
// module id = 201
// module chunks = 0